const TekilaMass=[
    // {
    //     id:1,
    //     title:"Хосе Куерво Еспешиал Сільвер (Мексика) 1л",
    //     price:"1800 грн",
    //     src: require('../img/jks.webp'),
    //     text:"50мл - 90 грн",
    // },
    // {
    //     id:2,
    //     title:"Хосе Куерво Еспешиал Репосадо (Мексика) 1л",
    //     price:"1800 грн",
    //     src: require('../img/jkg.webp'),
    //     text:"50мл - 90 грн",
    // },
    {
        id:3,
        title:"Харана Бланко 100% Блакитна Агава (Мексика) 1л",
        price:"2300 грн",
        src: require('../img/JaranaB.png'),
        text:"50мл - 115 грн",
    },
    {
        id:4,
        title:"Харана Репосадо 100% Блакитна Агава (Мексика) 1л",
        price:"2300 грн",
        src: require('../img/JaranaR.png'),
        text:"50мл - 115 грн",
    },
    
    
]

export default TekilaMass;